module.exports = __webpack_public_path__ + "img/sign-48.8d8d2330.jpg";